import { FlightDirect as OribtFlightDirect } from '@kiwicom/orbit-components/icons';
import type { Props as OrbitProps } from '@kiwicom/orbit-components/lib/Icon/types'; // There actually some usecase where we don't want to reverse on rtl

const FlightDirect = ({
  // It is still good to have it as default true rather than false though
  reverseOnRtl = true,
  ...props
}: OrbitProps): JSX.Element => {
  return <OribtFlightDirect {...props} reverseOnRtl={reverseOnRtl} />;
};

export default FlightDirect;
